<div *ngIf="disable" class="blocker"></div>
<ng-content></ng-content>
